import { Head, Link } from '@inertiajs/react'
import { AppShell } from '@/layouts/AppShell'
import { PageHeader } from '@/components/layout/PageHeader'
import { Card } from '@/components/ui/Card'
import type { Breadcrumb } from '@/types/shared'

export type TeamChatroomsIndexProps = {
  chatrooms: Array<{
    id: string
    playerName: string
    counterpartName: string
    lastMessage?: string | null
    lastMessageAt?: string | null
  }>
  breadcrumbs: Breadcrumb[]
}

export default function TeamChatroomsIndex({ chatrooms, breadcrumbs }: TeamChatroomsIndexProps) {
  return (
    <AppShell>
      <Head title="チャット一覧" />
      <PageHeader
        title="チャット一覧"
        description="選手とのメッセージ履歴を確認し、次のアクションに繋げましょう。"
        breadcrumbs={breadcrumbs}
      />

      <Card>
        {chatrooms.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-16 text-sm text-white/60">
            <p>まだチャットルームがありません。</p>
          </div>
        ) : (
          <ul className="divide-y divide-white/5">
            {chatrooms.map((chatroom) => (
              <li key={chatroom.id}>
                <Link
                  href={`/team/chatrooms/${chatroom.id}`}
                  className="flex items-start justify-between gap-4 px-4 py-4 text-sm text-white transition hover:bg-white/5"
                >
                  <div>
                    <p className="font-semibold text-white">{chatroom.playerName}</p>
                    <p className="text-xs text-white/60">{chatroom.counterpartName}</p>
                    <p className="mt-2 line-clamp-2 text-xs text-white/70">
                      {chatroom.lastMessage ?? 'メッセージはまだありません'}
                    </p>
                  </div>
                  {chatroom.lastMessageAt ? (
                    <time className="text-[11px] text-white/40">{formatDate(chatroom.lastMessageAt)}</time>
                  ) : null}
                </Link>
              </li>
            ))}
          </ul>
        )}
      </Card>
    </AppShell>
  )
}

function formatDate(value: string) {
  return new Date(value).toLocaleString('ja-JP', {
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}
